import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import withWidth from 'material-ui/utils/withWidth'
import {withStyles} from 'material-ui/styles/index'
import Container from '../../../common/components/Container'
import ErrorMessage from '../../../common/components/ErrorMessage'
import HeaderProgress from '../../../common/components/HeaderProgress'
import Typography from 'material-ui/Typography'
import ExpansionPanel, {ExpansionPanelSummary, ExpansionPanelDetails} from 'material-ui/ExpansionPanel'
import KeyboardArrowDownIcon from 'material-ui-icons/KeyboardArrowDown'
import classNames from 'classnames'
import {faqs as text} from '../text'

const styles = theme => ({
  topBanner: {
    marginTop: 0,
    padding: '45px 25px 40px 25px',
    backgroundColor: theme.palette.primary.main,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: -47,
    },
  },
  screenTitle: {
    color: '#FFF',
  },
  title: {
    maxWidth: 500,
    margin: '0 auto',
    color: '#FFF',
  },
  listTitle: {
    fontSize: '1.25rem',
    paddingTop: theme.spacing.unit * 4,
    paddingBottom: theme.spacing.unit * 4,
    paddingLeft: 0,
  },
  panel: {
    boxShadow: 'none',
    background: 'none',
    border: 'solid 1px',
    borderColor: theme.palette.border,
    '&::before': {
      opacity: 0,
    },
  },
  lastPanel: {
    borderBottom: 'solid 1px',
    borderBottomColor: theme.palette.border,
  },
  question: {
    backgroundColor: 'rgba(212,216,224,0.3)',
  },
  answer: {
    padding: 24,
    borderTop: 'solid 1px',
    borderTopColor: theme.palette.border,
  }
})

class Faqs extends React.Component {

  static displayName = 'Faqs.component'

  state = {
    expanded: null,
  }

  handleExpand = (faq) => {
    if (this.state.expanded === faq)
      this.setState({expanded: null})
    else
      this.setState({expanded: faq})
  }


  render() {
    const {classes, error, loading, faqs, selectedCategory} = this.props

    if (error !== '' && error !== undefined) {
      return <ErrorMessage error={error}/>
    }

    return (
      <div>
        <HeaderProgress show={loading}/>
        <div className={classes.topBanner}>
          <Typography variant={'subheading'} className={classes.screenTitle} gutterBottom={true}>
            {text.screenTitle}
          </Typography>
          <Typography variant={'display1'} className={classes.title} gutterBottom={true}>
            {selectedCategory ? selectedCategory.Name : ''}
          </Typography>
        </div>
        <Container>
          {faqs.map((c, index) => (
            <ExpansionPanel
              key={c.ID}
              expanded={this.state.expanded === c.ID}
              onChange={() => this.handleExpand(c.ID)}
              classes={{
                root: classNames(classes.panel, {[classes.lastPanel]: index === faqs.length - 1}),
              }}
            >
              <ExpansionPanelSummary
                className={classes.question}
                expandIcon={<KeyboardArrowDownIcon/>}
              >
                <Typography variant={'headline'} color={'primary'} style={{fontSize: '1.375rem'}}>
                  {c.Question}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.answer}>
                <Typography variant={'body1'} color={'textSecondary'} style={{whiteSpace: 'pre-line'}}>
                  {c.Answer}
                </Typography>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          ))}
        </Container>
      </div>
    )
  }

  static propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    faqs: PropTypes.array.isRequired,
    selectedCategory: PropTypes.object,
  }
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(Faqs)



// WEBPACK FOOTER //
// ./src/sections/help/components/faqs.js